import _ from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getCountries } from 'omega-rtc/actions/countries';
import ProgressiveContainer from 'omega-rtc/components/container/ProgressiveContainer';
import { isRequestsPending } from 'omega-rtc/utils/request-state-utils';

const AuthorizedUserContainer = ({ children, triggerFullView }) => {
  const dispatch = useDispatch();
  const countries = useSelector(state => state.countries.entities);
  const isLoggedIn = useSelector(state => state.app.isLoggedIn);
  const getCountriesRequest = useSelector(state => state.requests.getCountriesRequest || {});

  useEffect(() => {
    if (isLoggedIn && countries.length === 0) {
      dispatch(getCountries());
    }
  }, [isLoggedIn, countries.length, dispatch]);

  const isLoading = _.isEmpty(countries) || isRequestsPending(getCountriesRequest);

  if (isLoggedIn && !isLoading) {
    return (
      <div className="authorized">
        <ProgressiveContainer isLoading={isLoading} />
        {React.cloneElement(children, { triggerFullView })}
      </div>
    );
  }

  return null;
};

export default AuthorizedUserContainer;
